export default customElements.define('w-accordion-item', class AccordionItem extends wealthify.CustomElementBaseClass {

    constructor () {
        const selector = 'c-accordion-item';
        const config = {
            styleSelector: selector,
            templateHTML: `
                <details class="${selector}__details" data-root>
                    <summary class="${selector}__summary" data-summary>
                        <div class="${selector}__summary-title-wrapper" data-wrapper>
                            <span class="${selector}__title" data-slot="title" data-title></span>
                            <span data-slot="button" focusable="false" data-button></span>
                        </div>
                        <div class="${selector}__description" data-description></div>
                    </summary>
                    <div class="${selector}__content" data-content data-child-root></div>
                </details>`,
            hasChildren: true,
            defaultSlotContents: {
                button: '<w-widget-button icon="caret-down" iconactivated="caret-up" context="label" data-button data-slot="button"></w-widget-button>',
                title: '<h2 data-slot="title" data-title></h2>'
            },
            cacheDom: [ 'data-description', 'data-title', 'data-summary', 'data-content', 'data-button', 'data-wrapper' ]
        };

        super(config);
        
        this.animation = null;
        this.wasExpanded = false;
        
        this.onConnectedCallback = () => {
            this.classList.add(this.styleSelector);
            
            this.dom.summary.addEventListener('click', this._eventBindCallbacks.toggle);
            this.dom.button.addEventListener('click', this._eventBindCallbacks.toggle);
            this.dom.summary.addEventListener('mouseenter', () => this.dom.button.hovered = true);
            this.dom.summary.addEventListener('mouseleave', () => this.dom.button.hovered = false);

            this._toggleWithoutAnimation(this.open);
            this._setTitle();
        };
    }

    static get observedProps () {
        return [
            new wealthify.Prop('description'),
            new wealthify.Prop('open'),
            new wealthify.Prop('titleprop'),
            new wealthify.Prop('reversed', {
                default: false, 
                type: wealthify.propTypes.Boolean()
            }),
        ];
    }

    get propCallbacks () {
        return {
            description: (value) => this.dom.description.innerHTML = value,
            open: (value) => this._toggleWithoutAnimation(value),
            titleprop: () => this._setTitle(),
            reversed: () => {
                const classListAction = this.reversed ? 'add' : 'remove';

                this.dom.root.classList[classListAction](`${this.styleSelector}__summary--reversed`);
            }, 
        };
    }

    _eventBindCallbacks = {toggle: (event) => {
        event.preventDefault();

        if (this.animation) {
            return;
        }

        this.closedHeight = this.dom.summary.offsetHeight + Number.parseInt(getComputedStyle(this.dom.summary).marginBottom);
        this.dom.root.style.overflow = 'hidden';
        
        if (!this.dom.root.open) {
            this.dom.root.style.height = `${this.closedHeight}px`;
            this.dom.root.open = true;
        }
        
        this.openHeight = this.closedHeight + this.dom.content.offsetHeight + Number.parseInt(getComputedStyle(this.dom.content).marginBottom);

        const startHeight = this.wasExpanded ? `${this.openHeight}px` : `${this.closedHeight}px`;
        const endHeight = !this.wasExpanded ? `${this.openHeight}px` : `${this.closedHeight}px`;

        this.dom.button.activated = !this.wasExpanded;

        this.wasExpanded = !this.wasExpanded;
        this._dispatchToggledEvent();
      
        this.animation = this.dom.root.animate({height: [startHeight, endHeight]}, {
            duration: this.#transitionDuration,
            easing: this.#transitionEasing
        });
        
        this.animation.onfinish = () => {
            this.dom.root.open = this.wasExpanded;
            this.animation = null;
            this.dom.root.style.height = this.dom.root.style.overflow = '';

            const event = document.createEvent('Event');
            
            event.initEvent('togglecomplete', true, true);
            this.dispatchEvent(event);
        };
    }}

    // Private

    get #transitionDuration () {
        return Number.parseFloat(getComputedStyle(this.dom.root).transitionDuration) * 1000;
    }

    get #transitionEasing () {
        return getComputedStyle(this.dom.root).transitionTimingFunction;
    }

    _setTitle() {
        if (this.titleprop) {
            this.dom.title.innerHTML = this.titleprop;
        }
    }

    _toggleWithoutAnimation(open) {
        this.dom.root.open = open;
        this.dom.button.activated = open;
        this.wasExpanded = open;

        this._dispatchToggledEvent();
    }

    _dispatchToggledEvent() {
        const event = document.createEvent('Event');
            
        event.initEvent('toggled', true, true);
        this.dispatchEvent(event);
    }

    _reversed(){
        const classListAction = this.reversed ? 'add' : 'remove';

        this.dom.wrapper.classList[classListAction](`${this.styleSelector}__summary-title-wrapper--reversed`);
    }
});